import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
} from '../../../shared/components';
import CaracteristicaLenteCard from '../dataDisplay/CaracteristicaLenteCard';

export default function CaracteristicaLenteClickableCard({
  caracteristica, backgroundImage, onSelect, valorSeleccionado, idSeleccionada,
}) {
  const { id, valor, nombre } = caracteristica;
  let estaSeleccionada = false;

  if (id === idSeleccionada && valor === valorSeleccionado) {
    estaSeleccionada = true;
  }
  return (
    <CaracteristicaLenteCard
      estaSeleccionada={estaSeleccionada}
      handleOnClick={() => onSelect(caracteristica)}
      backgroundImage={backgroundImage}
    >
      <Text p="8" display="block" color={(estaSeleccionada) ? 'primary' : 'gray'}>
        {nombre}
        {' '}
        &nbsp;
      </Text>
    </CaracteristicaLenteCard>
  );
}
CaracteristicaLenteClickableCard.propTypes = {
  onSelect: PropTypes.func,
};
CaracteristicaLenteClickableCard.defaultProps = {
  onSelect: () => {},
};
